import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import softwareDetailsActions from '../actions/softwareDetails';

function getOnboardAdvertiserDetailsByEmail(store, action) {
    request.get(`/${config.url_prefix}/api/getOnboardAdvertiserDetailsByEmail?systemId=${action.payload.systemId}&emailAddress=${action.payload.emailAddress}&accountUuid=${action.payload.accountUuid}`)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(softwareDetailsActions.alertError(errorKey));
            } else {
                const parsedResponse = JSON.parse(response.text);
                store.dispatch(softwareDetailsActions.getOnboardAdvertiserDetailsByEmailSuccess(parsedResponse));
            }
        });
}

export default getOnboardAdvertiserDetailsByEmail;